import React from 'react';
import { Icon } from '../Icon/Icon.jsx';
import { BODY } from '../../primitives.js';

const h = React.createElement;

/**
 * Change over time: arrow + signed value; lime when the direction is good, coral when bad.
 *
 * @param {object} p
 * @param {React.ReactNode} p.value
 * @param {'up'|'down'|'flat'} [p.dir]
 * @param {'up'|'down'} [p.good]
 * @param {React.CSSProperties} [p.style]
 */
export function Trend({ value, dir = 'up', good = 'up', style }) {
  const tone = dir === 'flat' ? ['var(--neu-bg)', 'var(--tx2)'] : dir === good ? ['var(--lime-bg)', 'var(--lime-tx)'] : ['var(--coral-bg)', 'var(--coral-tx)'];
  return h('span', { style: { display: 'inline-flex', alignItems: 'center', gap: 3, padding: '2px 7px 2px 5px', borderRadius: 6, border: '1.5px solid var(--ink)', background: tone[0], color: tone[1], fontFamily: BODY, fontSize: 11.5, fontWeight: 800, fontVariantNumeric: 'tabular-nums', whiteSpace: 'nowrap', ...style } },
    h(Icon, { name: dir === 'up' ? 'arrow-up-right' : dir === 'down' ? 'arrow-up-right' : 'arrow-right', size: 13, stroke: 2.6, style: dir === 'down' ? { transform: 'scaleY(-1)' } : undefined }), value);
}
